import { render, staticRenderFns } from "./SearchSelection.vue?vue&type=template&id=a25ac68a&scoped=true&"
import script from "./SearchSelection.vue?vue&type=script&lang=js&"
export * from "./SearchSelection.vue?vue&type=script&lang=js&"
import style0 from "./SearchSelection.vue?vue&type=style&index=0&id=a25ac68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25ac68a",
  null
  
)

export default component.exports